import React from "react";
import { Layout } from "antd";
import Spacer from "../../../components/layouts/Spacer";
import Interfaces from "../../interfaces";

const { Content } = Layout;

const SyncSettings = (props) => {
  return (
    <Layout style={{ background: "transparent", height: "100%" }}>
      <Spacer horizontal={true} />

      <Content style={{ flex: 1 }}>
        <Interfaces />
      </Content>
    </Layout>
  );
};

export default SyncSettings;
